import {
    initValues,
    PostmediaStorage,
    StorageType,
    StorageTypes
} from 'constants/enums'

/**
 * Session storage module
 * `SessionStore.getInstance().get(Storages.XXX)` returns the value matched with `Storages.XXX`
 * `SessionStore.getInstance().set(Storages.XXX, value)` sets the value in `Storages.XXX`
 *
 * The overall purpose of this module is matching types of each items
 * i.g. `SessionStore.getInstance().get(Storages.XXX)` returns the value with exact type
 */
export class SessionStore {
    private readonly storeKey = 'postmedia/v1'

    /**
     * Singleton pattern
     */
    private static _instance: SessionStore
    public static getInstance(): SessionStore {
        return this._instance || (this._instance = new this())
    }

    /**
     * Get entire session
     * @returns {StorageType}
     */
    private getAll(): StorageType {
        const session = sessionStorage.getItem(this.storeKey)
        return session ? (JSON.parse(session) as StorageType) : initValues
    }

    /**
     * Get specific session
     * @template T extends Storages
     * @param {T} key
     * @returns {StorageType<T>}
     */
    public get<T extends PostmediaStorage>(key: T): StorageTypes<T> {
        const value = this.getAll()
        return value[key] as StorageTypes<T>
    }

    /**
     * Set specific session
     * @template T extends Storages
     * @param {T} key
     * @param {StorageTypes<T>} value
     */
    public set<T extends PostmediaStorage>(
        key: T,
        value: StorageTypes<T>
    ): void {
        const session = this.getAll()
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        session[key] = value as any
        sessionStorage.setItem(this.storeKey, JSON.stringify(session))
    }
}
